var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7273 21.1493V17.6367C18.6177 17.6511 18.5016 17.658 18.3847 17.658H2.84257C2.72642 17.658 2.61689 17.6511 2.5 17.6367V21.1493C2.5 23.0501 3.99967 24.5913 5.83455 24.5913H15.3927C17.2276 24.5905 18.7273 23.0501 18.7273 21.1493Z",
    fill: "#1b4597"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5644 11.4841H17.3173V7.46882C17.3173 7.10411 17.0021 6.81836 16.6169 6.81836C16.2318 6.81836 15.9166 7.10481 15.9166 7.46882V11.4841H5.30954V7.46882C5.30954 7.10411 4.99436 6.81836 4.60922 6.81836C4.22408 6.81836 3.9089 7.10481 3.9089 7.46882V11.4841H2.66172C1.29568 11.4841 0.181641 12.5188 0.181641 13.7876C0.181641 15.0564 1.29568 16.0911 2.66172 16.0911H18.5652C19.9312 16.0911 21.0453 15.0564 21.0453 13.7876C21.0453 12.5188 19.9305 11.4841 18.5644 11.4841Z",
    fill: "#1b4597"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0539 0.636719C8.89418 0.636719 7.13672 2.39418 7.13672 4.55386C7.13672 6.71048 8.89418 8.46794 11.0539 8.46794C13.2135 8.46794 14.971 6.71048 14.971 4.55386C14.971 2.39418 13.2135 0.636719 11.0539 0.636719ZM12.4931 3.9099L10.7611 5.64186C10.6992 5.70374 10.6183 5.73468 10.5371 5.73468C10.4561 5.73468 10.3749 5.70374 10.313 5.64186L9.61396 4.94282C9.4902 4.81906 9.4902 4.6188 9.61396 4.49504C9.73772 4.37128 9.93798 4.37128 10.0617 4.49504L10.5371 4.97036L12.0453 3.46212C12.1691 3.33836 12.3693 3.33836 12.4931 3.46212C12.6168 3.58588 12.6168 3.78614 12.4931 3.9099Z",
    fill: "#1b4597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderblue);
export default __webpack_public_path__ + "static/media/orderblue.e1ff4f096dc290d6a9ec0e5b13cdd56d.svg";
export { ForwardRef as ReactComponent };